export default __webpack_public_path__ + "static/media/income.2864d367.svg";